<div class="custom-modal painel-cte-entidades">
  <div class="header">
    <h1 mat-dialog-title>
      Alteração Entidade {{tipoEntidade}}
    </h1>
    <mat-icon mat-dialog-close="cancel">close</mat-icon>
  </div>
  <mat-divider></mat-divider>
  <div *ngIf="isLoading" style="min-height: 120px" class="d-flex justify-content-center">
    <mat-spinner color="primary" mode="indeterminate"></mat-spinner>
  </div>
  <div mat-dialog-content *ngIf="!isLoading">
    <form [formGroup]="formEntidade">
      <div class="element-inline">
        <mat-radio-group formControlName="tipoPessoa">
          <mat-radio-button value="F">Física</mat-radio-button>
          <mat-radio-button value="J" class="ml-2">Jurídica</mat-radio-button>
        </mat-radio-group>
        
        <mat-form-field>
          <mat-label>CGC</mat-label>
          <input matInput
            required
            autocomplete="off"
            formControlName="cgc"
            [mask]="formEntidade.get('tipoPessoa').value === 'F' ? '000.000.000-00' : '00.000.000/0000-00'"
            maxLength="18"
            placeholder="CGC" />
        </mat-form-field>
      </div>

      <div class="element-inline">
        <mat-form-field>
          <mat-label>Razão Social</mat-label>
          <input matInput
            required
            autocomplete="off"
            formControlName="razaoSocial"
            placeholder="Razão Social"
            maxlength="100" />
        </mat-form-field>
  
        <mat-form-field>
          <mat-label>Inscrição Estadual</mat-label>
          <input matInput
            required
            autocomplete="off"
            formControlName="inscricaoEstadual"
            placeholder="Inscrição Estadual"
            maxlength="14"/>
        </mat-form-field>
      </div>

      <ng-container formGroupName="endereco">
        <div class="element-inline">
          <mat-form-field>
            <mat-label>CEP</mat-label>
            <input matInput
              required
              mask="00000-000"
              autocomplete="off"
              formControlName="cep"
              placeholder="CEP"
              maxlength="9"
              (blur)="consultarCep()"/>
          </mat-form-field>

          <mat-form-field class="endereco-ibge">
            <mat-label>IBGE</mat-label>
            <input matInput
              required
              autocomplete="off"
              formControlName="ibge"
              placeholder="IBGE"
              maxlength="5" />
          </mat-form-field>

          <mat-form-field class="endereco-uf">
            <mat-label>UF</mat-label>
            <mat-select formControlName="uf" required>
              <mat-option *ngFor="let uf of listaUF" [value]="uf.sigla">
                {{ uf.sigla }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field>
            <mat-label>Municipio</mat-label>
            <input matInput
              required
              autocomplete="off"
              formControlName="municipio"
              placeholder="Municipio"
              maxlength="100" />
          </mat-form-field>
        </div>

        <div class="element-inline">
          <mat-form-field>
            <mat-label>Bairro</mat-label>
            <input matInput
              required
              autocomplete="off"
              formControlName="bairro"
              placeholder="Bairro"
              maxlength="40" />
          </mat-form-field>
    
          <mat-form-field>
            <mat-label>Endereço</mat-label>
            <input matInput
              required
              autocomplete="off"
              formControlName="logradouro"
              placeholder="Endereço"/>
              <mat-error *ngIf="formEntidade.get(['endereco', 'logradouro']).errors['maxlength']">
                  Campo endereço pode ter no máximo 40 caracteres!
              </mat-error>
            </mat-form-field>
        </div>
      </ng-container>
    </form>
  </div>
  <div class="modal-actions" mat-dialog-actions align="end">
    <button mat-flat-button
      color="info"
      mat-dialog-close="cancel"
      [disabled]="isLoading">
        Cancelar
    </button>
    <button mat-flat-button
      color="primary"
      (click)="editarEntidade()"
      [disabled]="formEntidade.status !== 'VALID'"
    >
        OK
    </button>
  </div>
</div>